import { createReducer, on } from '@ngrx/store';

import { initialAuthState } from './state';
import { setUser, clearUser, setUserId, setUserNombre, setUserUsuario, setUserCelular } from './actions';

export const authReducer = createReducer(
  initialAuthState,
  on(setUser, (state, { user }) => ({
    ...state,
    ...user
  })),
  on(clearUser, () => ({
    ...initialAuthState
  })),
  on(setUserId, (state, { id_user }) => ({ ...state, id_user })),
  on(setUserNombre, (state, { nombre }) => ({ ...state, nombre })),
  on(setUserUsuario, (state, { usuario }) => ({ ...state, usuario })),
  on(setUserCelular, (state, { celular }) => ({ ...state, celular }))
);